import { render } from "./ViewBatchWithAnyWaitingStatus.vue?vue&type=template&id=2bb7bda0"
import script from "./ViewBatchWithAnyWaitingStatus.vue?vue&type=script&lang=js"
export * from "./ViewBatchWithAnyWaitingStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__